export const formatBelgianNationalNumberPartial = (number: string): string => {
	const numberString = number.replace(/\D/g, '').replace(/\./g, '')
	if (numberString === '') return numberString

	// const numberString = Number(number).toString()
	let formattedNumber = ''

	// Jaar: Eerste 2 cijfers
	if (numberString.length >= 2) {
		formattedNumber += `${numberString.slice(0, 2)}.`
	} else {
		return numberString // Retourneert het getal zoals het is als er minder dan 2 cijfers zijn.
	}

	// Maand: Volgende 2 cijfers
	if (numberString.length >= 4) {
		const month = Number(numberString.slice(2, 4))
		// validate month
		if (month === 0 || month > 12)
			return formattedNumber + `${numberString.slice(2, 4)}`
		formattedNumber += `${numberString.slice(2, 4)}.`
	} else {
		return formattedNumber + numberString.slice(2) // Retourneert tot zover ingevoerd
	}

	// Dag: Volgende 2 cijfers
	if (numberString.length >= 6) {
		const day = Number(numberString.slice(4, 6))
		// validate day
		if (day === 0 || day > 31)
			return formattedNumber + `${numberString.slice(4, 6)}`
		formattedNumber += `${numberString.slice(4, 6)}-`
	} else {
		return formattedNumber + numberString.slice(4)
	}

	// Volgnummer: Volgende 3 cijfers
	if (numberString.length >= 9) {
		formattedNumber += `${numberString.slice(6, 9)}.`
	} else {
		return formattedNumber + numberString.slice(6)
	}

	// Controlegetal: Laatste 2 cijfers
	if (numberString.length >= 11) {
		// validate controlegetal
		const baseNumber = parseInt(numberString.slice(0, 9), 10)
		const controlNumber = parseInt(numberString.slice(9, 11), 10)
		let calculatedControl = 97 - (baseNumber % 97)

		if (calculatedControl !== controlNumber) {
			calculatedControl = 97 - ((baseNumber + 2000000000) % 97) // for people born after 31/12/1999
			if (calculatedControl !== controlNumber) {
				return formattedNumber + numberString.slice(9, 9)
			}
		}

		formattedNumber += `${numberString.slice(9, 11)}`
	} else {
		return formattedNumber + numberString.slice(9)
	}

	return formattedNumber
}
